// Module
var code = "<div>\n    <md-menu-item ng-show=\"bike.status == 'USED' || bike.status == 'BROKEN'\">\n        <md-button href=\"{{ bla.createRequestLink() }}\">\n            Book service\n        </md-button>\n    </md-menu-item>\n    <md-menu-item>\n        <md-button ng-click=\"bla.changeStatus($event, bike)\">Change status</md-button>\n    </md-menu-item>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/bike/list/base/bl-item-basic-actions.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;